import React from 'react';
import ContentLoader from 'react-content-loader';

const BarChartLoader = ({ width = '100%', height = 300, barCount = 8 }) => {
  const chartWidth = 500;
  const barWidth = 40;
  const barSpacing = (chartWidth - barWidth) / (barCount - 1);

  // Generate bars at different heights to simulate realistic chart data
  const barHeights = [160, 120, 180, 80, 140, 100, 200, 90, 150, 110];

  return (
    <ContentLoader
      width={width}
      height={height}
      viewBox={`0 0 ${chartWidth} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      speed={1.5}
    >
      {/* Chart bars */}
      {Array.from({ length: barCount }, (_, i) => (
        <rect
          key={`bar-${i}`}
          x={50 + i * barSpacing}
          y={height - barHeights[i] - 20}
          rx="4"
          ry="4"
          width={barWidth}
          height={barHeights[i]}
        />
      ))}
    </ContentLoader>
  );
};

export default BarChartLoader;
